import React from "react";

const InitialsAvatar = ({ name, size }) => {
    if (!name || typeof name !== "string" || name.trim() === "") {
        return (
            <div className="iniciais-nome">
                <div>-</div>
            </div>
        );
    }

    const nameParts = name.trim().split(" ").filter(Boolean);
    const initials =
        nameParts.length > 1
            ? `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase()
            : nameParts[0][0].toUpperCase();

    return (
        <div className={`iniciais-nome ${size}`}>
            <div>{initials}</div>
        </div>
    );
};

export default InitialsAvatar;
